import React, { useState } from 'react';
import AuthContext, { UserRole } from './AuthContext';

interface AuthProviderProps {
    children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState<UserRole | null>(null);

    const setAuth = (auth: boolean) => {
        setIsAuthenticated(auth);
        if (!auth) {
            setUserRole(null);
        }
    };

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            userRole,
            setAuth,
            setUserRole
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider; 